import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../shared/Navbars/DashboardNavbar";
import Footer from "../../shared/Footer";
import ComplexStatisticsCard from "../../shared/Cards/StatisticsCards/ComplexStatisticsCard";

// Service
import articleService from "../../services/articleService";
import logService from "../../services/logService";
import { formatDate } from "../../utils/formatDate";

function Dashboard() {
  const [stats, setStats] = useState({
    total: 0,
    published: 0,
    review: 0,
    activeUsers: 0,
    mostRead: []
  });
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await articleService.getStats();
        setStats(response.data);
      } catch (error) {
        console.error("Error fetching stats:", error);
      }
    };
    fetchStats();
  }, []);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await logService.getAll();
        setLogs(response.data);
      } catch (error) {
        console.error("Error fetching logs:", error);
      }
    };
    fetchLogs();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="article"
                title="Total Artículos"
                count={stats.total}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "En total",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="check_circle"
                title="Publicados"
                count={stats.published}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Visible para todos",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="pending"
                title="En Revisión"
                count={stats.review}
                percentage={{
                  color: "warning",
                  amount: "",
                  label: "Pendiente de acción",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person"
                title="Usuarios Activos"
                count={stats.activeUsers}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "En el último mes",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Card>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Artículos más leídos
                  </MDTypography>
                </MDBox>
                <MDBox p={2}>
                  {stats.mostRead.length > 0 ? (
                    stats.mostRead.map((article) => (
                      <MDBox key={article._id} mb={2} display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="button" fontWeight="regular">
                          {article.title}
                        </MDTypography>
                        <MDTypography variant="caption" color="text">
                          {article.views} visitas
                        </MDTypography>
                      </MDBox>
                    ))
                  ) : (
                    <MDTypography variant="caption">No data available</MDTypography>
                  )}
                </MDBox>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Acciones Recientes
                  </MDTypography>
                </MDBox>
                <MDBox p={2}>
                  {logs.length > 0 ? (
                    logs.slice(0, 5).map((log) => (
                      <MDBox key={log._id} mb={2} display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="button" fontWeight="regular">
                          {log.user?.username || "Usuario desconocido"} {log.action}
                        </MDTypography>
                        <MDTypography variant="caption" color="text">
                          {formatDate(log.createdAt)}
                        </MDTypography>
                      </MDBox>
                    ))
                  ) : (
                    <MDTypography variant="caption">No data available</MDTypography>
                  )}
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;

